module.exports = function anonymous(it
/*``*/) {
var out='<div class="matches"> <ul> ';var arr1=it;if(arr1){var item,i1=-1,l1=arr1.length-1;while(i1<l1){item=arr1[i1+=1];out+=' <li class="matches__item"><a href="#" data-id="'+(item.Id)+'" data-text="'+(item.Text)+'" data-action="'+(item.Next)+'">'+(item.Text)+'<span class="matches__item__description">'+(item.Description)+'</span></a></li> ';} } out+=' </ul></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/fuzzyMatches.dot
// module id = 24
// module chunks = 0